import React from 'react';
import TextWinds from '../../../../../components/common/TextWinds';
import HFbutton from '../../../../../components/common/input/HFbutton';
import { useNavigate } from 'react-router-dom';
import { ToDoMgmtSubType } from '../../../../../enum';

interface InvalidAccessProps {
  classId: string;
}

const InvalidAccess: React.FC<InvalidAccessProps> = ({ classId }) => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate(
      `/lms/${classId}/todo-management/jebs_ai_recitation?stage=state&type=${ToDoMgmtSubType.JEBS_AI_RECITATION}`,
      { replace: true },
    );
  };

  return (
    <div className="flex flex-col items-center justify-center gap-6 rounded-lg bg-white p-5 sm:p-8 sm:shadow-card">
      <div className="flex flex-col items-center gap-2 text-center">
        <TextWinds type="title_h3" color="gray7">
          기존 인증제를 이용해주셔서 감사합니다
        </TextWinds>
        <div className="mt-2 text-sm text-gray6 sm:text-base">
          기존 인증제는 2025년 5월 31일부로 종료되었습니다.
          <br />
          AI 인증제를 이용해주세요.
        </div>
      </div>
      <div className="flex gap-3">
        <HFbutton height={40} onClick={handleRedirect}>
          AI 인증제로 이동
        </HFbutton>
      </div>
    </div>
  );
};

export default InvalidAccess;
